enum ExpandResponseType {
  ADDRESS = 'Address',
  ADDRESSES = 'Addresses',
  DOCUMENTS = 'Documents',
  DIGESTATE_PRODUCT = 'DigestateProduct',
  ASSIGNED_EMPLOYEE = 'AssignedEmployee',
  ASSIGNED_EMPLOYEES = 'AssignedEmployees',
  ASSIGNED_VEHICLE = 'AssignedVehicle',
  ASSIGNED_EQUIPMENT = 'AssignedEquipment',
  PICKUP_AD_PLANT_SITE = 'PickupADPlantSite',
  PICKUP_AD_PLANT_SITE_INFO = 'CollectionSiteInfo',
  DELIVERY_AD_PLANT_SITE = 'DeliveryADPlantSite',
  DELIVERY_AD_PLANT_SITE_INFO = 'DeliverySiteInfo',
  AD_PLANT_SITE = 'AdPlantSite',
  WASTE_DELIVERY_SITE = 'WasteDeliverySite',
  PURCHASE_ORDER_DOCUMENTS = 'PurchaseOrderDocuments',
  DROP_SITE_INFO = 'DropSiteInfo',
  HAULAGE_JOB = 'HaulageJob',
  DIGESTATE_JOB = 'DigestateJob',
  SPREADING_JOB = 'SpreadingJob',
  USER = 'User',
  PRICE = 'Price',
  TOTAL_AMOUNT = 'TotalAmount',
  SILO = 'Silo',
  SILOS = 'Silos',
  FARM = 'Farm',
  FIELDS = 'Fields',
  FIELD = 'Field',
  VEHICLE = 'Vehicle',
  EQUIPMENT = 'Equipment',
  CUSTOMER = 'Customer',
  EMPLOYEE = 'Employee',
  WIND_SPEED = 'WindSpeed',
  TEMPERATURE = 'Temperature',
  WASTE_COLLECTION_PROVIDER = 'WasteCollectionProvider',
  WASTE_COLLECTION_SITE = 'WasteCollectionSite',
  WASTE_COLLECTION_SITE_INFO = 'WasteCollectionSiteInfo',
  WASTE_PRODUCT = 'WasteProduct',
  BREAK_TIME_ENTRIES = 'BreakTimeEntries',
  DAILY_COST = 'DailyCost',
  WASTE_COLLECTION_PROVIDER_PRODUCT = 'WasteCollectionProvider.WasteProduct',
  WASTE_COLLECTION_PROVIDER_COLLECTION_SITE = 'WasteCollectionProvider.WasteCollectionSite',
  WASTE_COLLECTION_PROVIDER_AD_PLANT_SITE = 'WasteCollectionProvider.AdPlantSite',
  WASTE_COLLECTION_PROVIDER_WASTE_DELIVERY_SITE = 'WasteCollectionProvider.WasteDeliverySite',
  SIGNATURE = 'Signature'
}

export default ExpandResponseType
